import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import {
  type AuthLogin,
  type FabricLoginCallbackData,
  type FabricLoginOptions,
} from './types.js';

export const forceLogin: AuthLogin = <UserInfo extends Json = Json>() => {
  return new Promise<FabricLoginCallbackData<UserInfo>>((resolve, reject) => {
    core.call<
      'fabric_auth.login',
      FabricLoginOptions,
      FabricLoginCallbackData<UserInfo>
    >(
      'fabric_auth.login',
      {
        force: true,
      },
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
